// imports
import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Image,
  Button,
  Navbar,
  Form,
  Nav,
  ProgressBar,
  Alert,
} from "react-bootstrap";
import AccessRequestService from "../services/accessRequest.service";
import { Wave, Portfolio, Logo } from "../img";
import "./Register.css";

// component Register
export default class Register extends Component {
  constructor(props) {
    super(props);

    this.handleRegister = this.handleRegister.bind(this);
    this.onChangeUsername = this.onChangeUsername.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);
    this.onChangeFundPassword = this.onChangeFundPassword.bind(this);
    this.onChangeReason = this.onChangeReason.bind(this);

    this.state = {
      username: "",
      email: "",
      password: "",
      fundPassword: "",
      reason: "",
      successful: false,
      loading: false,
      message: "",
      userInvalid: false,
      emailInvalid: false,
      pwInvalid: false,
      fundPwInvalid: false,
      pwStrength: 0,
      pwColor: "",
    };
  }

  onChangeUsername(e) {
    this.setState({
      username: e.target.value,
      message: "",
      userInvalid: false,
    });

    if (5 > e.target.value.length || e.target.value.length > 20) {
      this.setState({ userInvalid: true });
    }
  }

  onChangeEmail(e) {
    this.setState({
      email: e.target.value,
      message: "",
      emailInvalid: false,
    });
  }

  onChangeReason(e) {
    this.setState({
      reason: e.target.value,
      message: ""
    });
  }

  onChangePassword(e) {
    this.setState({
      password: e.target.value,
      message: "",
      pwInvalid: false,
    });

    if (8 > e.target.value.length || e.target.value.length > 20) {
      this.setState({ pwInvalid: true });
    }

    switch (e.target.value.length) {
      case 0:
        this.setState({ pwStrength: 0, pwColor: "danger" });
        break;
      case 1:
        this.setState({ pwStrength: 6.25, pwColor: "danger" });
        break;
      case 2:
        this.setState({ pwStrength: 12.5, pwColor: "danger" });
        break;
      case 3:
        this.setState({ pwStrength: 18.75, pwColor: "danger" });
        break;
      case 4:
        this.setState({ pwStrength: 25, pwColor: "danger" });
        break;
      case 5:
        this.setState({ pwStrength: 31.25, pwColor: "danger" });
        break;
      case 6:
        this.setState({ pwStrength: 37.5, pwColor: "danger" });
        break;
      case 7:
        this.setState({ pwStrength: 43.75, pwColor: "danger" });
        break;
      case 8:
        this.setState({ pwStrength: 50, pwColor: "warning" });
        break;
      case 9:
        this.setState({ pwStrength: 56.25, pwColor: "warning" });
        break;
      case 10:
        this.setState({ pwStrength: 62.5, pwColor: "warning" });
        break;
      case 11:
        this.setState({ pwStrength: 68.75, pwColor: "warning" });
        break;
      case 12:
        this.setState({ pwStrength: 75, pwColor: "warning" });
        break;
      case 13:
        this.setState({ pwStrength: 81.25, pwColor: "success" });
        break;
      case 14:
        this.setState({ pwStrength: 87.5, pwColor: "success" });
        break;
      case 15:
        this.setState({ pwStrength: 93.25, pwColor: "success" });
        break;
      case 16:
      case 17:
      case 18:
      case 19:
      case 20:
        this.setState({ pwStrength: 100, pwColor: "success" });
        break;
      default:
        this.setState({ pwStrength: 100, pwColor: "danger" });
    }
  }

  onChangeFundPassword(e) {
    this.setState({
      fundPassword: e.target.value,
      message: "",
      fundPwInvalid: false,
    });
  }

  handleRegister(e) {
    e.preventDefault();

    this.setState({
      message: "",
      loading: true,
    });

    if (
      this.state.username === "" ||
      this.state.email === "" ||
      this.state.password === "" ||
      this.state.fundPassword === ""
    ) {
      this.setState({
        userInvalid: !this.state.username,
        emailInvalid: !this.state.email,
        pwInvalid: !this.state.password,
        fundPwInvalid: !this.state.fundPassword,
        loading: false,
      });
      return;
    }

    if (
      this.state.userInvalid ||
      this.state.emailInvalid ||
      this.state.pwInvalid ||
      this.state.fundPwInvalid
    ) {
      this.setState({
        loading: false,
      });
      return;
    }

    AccessRequestService.submitRequest(
      this.state.name || this.state.username,
      this.state.email,
      this.state.reason,
      this.state.username,
      this.state.password,
      this.state.fundPassword
    ).then(
      (response) => {
        this.setState({
          successful: true,
          message: response.data.message || "Request submitted successfully. Please wait for admin approval.",
          loading: false
        });
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        this.setState({
          successful: false,
          loading: false,
          message: resMessage,
        });
      }
    );
  }

  render() {
    return (
      <Container fluid className="register-container">
        {/* Wave background for desktop */}
        <Image src={Wave} className="wave-background position-fixed h-100 d-none d-md-block"></Image>

        {/* NAVBAR WITH LOGO - For BOTH mobile and desktop */}
        <Navbar className="register-navbar">
          <Container className="px-3">
            <Navbar.Brand href="/" className="register-brand d-flex align-items-center">
              <img 
                src={Logo} 
                alt="Super Coin" 
                className="logo-img"
              />
              <span className="ms-2 navbar-title">
                Super Coin
              </span>
            </Navbar.Brand>
          </Container>
        </Navbar>

        <Row className="main-content align-items-center justify-content-center">
          {/* Left Column - Desktop only */}
          <Col lg={6} md={6} className="left-col d-none d-md-flex">
            <div className="left-content">
              <div className="logo-display text-center mb-4">
                <img src={Logo} alt="Super Coin" className="large-logo" />
                <h1 className="brand-title">Super Coin</h1>
                <p className="brand-tagline">Secure Digital Trading Platform</p>
              </div>
              <Image
                src={Portfolio}
                className="mx-auto my-auto portfolio-image"
                fluid
              ></Image>
            </div>
          </Col>

          {/* Right Column - Form */}
          <Col lg={6} md={6} xs={12} className="right-col">
            <div className="register-form-container mx-auto">
              {/* Form Header - Desktop */}
              <div className="form-header text-center mb-4 d-none d-md-block">
                <div className="form-logo-container">
                  <img src={Logo} alt="Super Coin" className="form-logo" />
                </div>
                <h1 className="register-title">Request Access</h1>
                <p className="register-subtitle">Create your account request</p>
              </div>

              {/* Mobile Form Header */}
              <div className="mobile-form-header text-center mb-4 d-block d-md-none">
                <div className="mobile-header-logo mb-8">
                  <img 
                    src={Logo} 
                    alt="Super Coin" 
                    className="mobile-logo"
                  />
                </div>
                <h3 className="mobile-title">Welcome</h3>
                <p className="mobile-subtitle">
                  Sign in to your account
                </p>
              </div>
              
              <Form className="text-center" onSubmit={this.handleRegister}>
                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Username"
                    onChange={this.onChangeUsername}
                    isInvalid={this.state.userInvalid}
                    className="register-input"
                  />
                  <Form.Text className="char-limit-text">
                    Must be between 5 and 20 characters
                  </Form.Text>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Control
                    type="email"
                    placeholder="Email"
                    onChange={this.onChangeEmail}
                    isInvalid={this.state.emailInvalid}
                    className="register-input"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Control
                    type="password"
                    placeholder="Password"
                    onChange={this.onChangePassword}
                    isInvalid={this.state.pwInvalid}
                    className="register-input"
                  />
                  <ProgressBar
                    className="mt-1 password-strength-bar"
                    now={this.state.pwStrength}
                    variant={this.state.pwColor}
                  ></ProgressBar>
                  <Form.Text className="password-hint">
                    8-20 characters recommended
                  </Form.Text>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Control
                    type="password"
                    placeholder="Fund Password (for withdrawals)"
                    onChange={this.onChangeFundPassword}
                    isInvalid={this.state.fundPwInvalid}
                    className="register-input"
                  />
                  <Form.Text className="fund-password-text">
                    Separate password for financial transactions
                  </Form.Text>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Control
                    as="textarea"
                    rows={2}
                    placeholder="Reason for joining (Optional)"
                    onChange={this.onChangeReason}
                    className="reason-textarea"
                  />
                </Form.Group>

                <Alert variant={this.state.successful ? "success" : "danger"} 
                       show={!!this.state.message}
                       className="register-alert">
                  {this.state.message}
                </Alert>

                {!this.state.successful && (
                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100 mb-3 register-btn"
                    disabled={this.state.loading}
                  >
                    {this.state.loading ? "Submitting..." : "Request Access"}
                  </Button>
                )}

                <Nav className="justify-content-center login-link-container">
                  <Nav.Item>
                    <Nav.Link disabled className="login-text">
                      Already have an account?
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link href="./login" className="login-link">
                      <u>Click here</u>
                    </Nav.Link>
                  </Nav.Item>
                </Nav>

                {/* Admin Login Link */}
                <div className="admin-login-link mt-3">
                  <Nav.Link href="./admin-login" className="text-center admin-link">
                    Login as Administrator
                  </Nav.Link>
                </div>
              </Form>
            </div>
          </Col>
        </Row>

        {/* Mobile Footer */}
        <div className="mobile-footer d-block d-md-none">
          <p className="text-center footer-text">
            © 2024 Super Coin. All rights reserved.
          </p>
        </div>
      </Container>
    );
  }
}